import { put } from 'redux-saga/effects';
import DoorControlsActions from '../redux/DoorControlsRedux';
import i18n from '../i18n';

export function* getDoorControls(api, { pageParams, customerId }) {
  try {
    const getDoorControlsResponse = yield api.getDoorControls(pageParams, customerId);
    console.log('getDoorControlsResponse:', getDoorControlsResponse);
    if (getDoorControlsResponse.ok) {
      yield put(
        DoorControlsActions.getDoorControlsRequestSuccess(
          getDoorControlsResponse.data.content,
          getDoorControlsResponse.data.totalElements
        )
      );
    } else {
      api.checkAuth(getDoorControlsResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof getDoorControlsResponse.problem !== 'undefined'
          ? getDoorControlsResponse.problem
          : typeof getDoorControlsResponse.data.error !== 'undefined'
          ? getDoorControlsResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(DoorControlsActions.getDoorControlsRequestFailure(error));
    }
  } catch (error) {
    console.log('error in doorControls saga', error);
    yield put(DoorControlsActions.getDoorControlsRequestFailure(error));
  }
}

export function* createDoorControl(
  api,
  { doorControlInfo, controllers, doorControlParams, controllersParams, customerId }
) {
  try {
    const createDoorControlResponse = yield api.createDoorControl(doorControlInfo);
    console.log('createDoorControlResponse:', createDoorControlResponse);
    const getDoorControlsResponse = yield api.getDoorControls(doorControlParams, customerId);
    const { doorControlId } = createDoorControlResponse.data;
    const addDoorControlControllersResponse = yield api.addDoorControlControllers(doorControlId, controllers);
    console.log('(create door control) addDoorControlControllersResponse:', addDoorControlControllersResponse);
    const getDoorControlControllersResponse = yield api.getDoorControlControllers(doorControlId, controllersParams);
    console.log('(create door control) getDoorControlControllersResponse:', getDoorControlControllersResponse);
    const successMessage = i18n.t('successMessage.createDoorControlSuccess');
    console.log('(create door control) getDoorControlsResponse:', getDoorControlsResponse);
    if (createDoorControlResponse.ok && getDoorControlsResponse.ok) {
      yield put(
        DoorControlsActions.createDoorControlRequestSuccess(
          createDoorControlResponse.data.doorControlId,
          getDoorControlsResponse.data.content,
          getDoorControlsResponse.data.totalElements,
          getDoorControlControllersResponse.data.content,
          getDoorControlControllersResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(createDoorControlResponse);
      api.checkAuth(getDoorControlsResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof createDoorControlResponse.problem !== 'undefined'
          ? createDoorControlResponse.problem
          : typeof createDoorControlResponse.data.error !== 'undefined'
          ? createDoorControlResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(DoorControlsActions.createDoorControlRequestFailure(error));
    }
  } catch (error) {
    console.log('error in doorControls saga', error);
    yield put(DoorControlsActions.createDoorControlRequestFailure(error));
  }
}

export function* editDoorControl(api, { doorControlInfo, pageParams, customerId }) {
  try {
    const editDoorControlResponse = yield api.editDoorControl(doorControlInfo);
    console.log('editDoorControlResponse:', editDoorControlResponse);
    const getDoorControlsResponse = yield api.getDoorControls(pageParams, customerId);
    const successMessage = i18n.t('successMessage.editDoorControlSuccess');
    console.log('getDoorControlsResponse:', getDoorControlsResponse);
    if (editDoorControlResponse.ok && getDoorControlsResponse.ok) {
      yield put(
        DoorControlsActions.editDoorControlRequestSuccess(
          getDoorControlsResponse.data.content,
          getDoorControlsResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(editDoorControlResponse);
      api.checkAuth(getDoorControlsResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof editDoorControlResponse.problem !== 'undefined'
          ? editDoorControlResponse.problem
          : typeof editDoorControlResponse.data.error !== 'undefined'
          ? editDoorControlResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(DoorControlsActions.editDoorControlRequestFailure(error));
    }
  } catch (error) {
    console.log('error in doorControls saga', error);
    yield put(DoorControlsActions.editDoorControlRequestFailure(error));
  }
}

export function* deleteDoorControl(api, { doorControlId, pageParams, customerId }) {
  console.log('doorControlId:', doorControlId);
  try {
    const deleteDoorControlResponse = yield api.deleteDoorControl(doorControlId);
    console.log('deleteDoorControlResponse:', deleteDoorControlResponse);
    const getDoorControlsResponse = yield api.getDoorControls(pageParams, customerId);
    const successMessage = i18n.t('successMessage.deleteDoorControlSuccess');
    console.log('(delete doorControl) getDoorControlsResponse:', getDoorControlsResponse);
    if (deleteDoorControlResponse.ok && getDoorControlsResponse.ok) {
      yield put(
        DoorControlsActions.deleteDoorControlRequestSuccess(
          getDoorControlsResponse.data.content,
          getDoorControlsResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(deleteDoorControlResponse);
      api.checkAuth(getDoorControlsResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof deleteDoorControlResponse.problem !== 'undefined'
          ? deleteDoorControlResponse.problem
          : typeof deleteDoorControlResponse.data.error !== 'undefined'
          ? deleteDoorControlResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(DoorControlsActions.deleteDoorControlRequestFailure(error));
    }
  } catch (error) {
    console.log('error in doorControls saga', error);
    yield put(DoorControlsActions.deleteDoorControlRequestFailure(error));
  }
}

export function* getAvailableDoorControlsControllers(api, { pageParams, customerId }) {
  try {
    const getAvailableControllersResponse = yield api.getAvailableDoorControlsControllers(pageParams, customerId);
    console.log('getAvailableControllersResponse:', getAvailableControllersResponse);
    if (getAvailableControllersResponse.ok) {
      yield put(
        DoorControlsActions.getAvailableControllersRequestSuccess(
          getAvailableControllersResponse.data.content,
          getAvailableControllersResponse.data.totalElements
        )
      );
    } else {
      api.checkAuth(getAvailableControllersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof getAvailableControllersResponse.problem !== 'undefined'
          ? getAvailableControllersResponse.problem
          : typeof getAvailableControllersResponse.data.error !== 'undefined'
          ? getAvailableControllersResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(DoorControlsActions.getAvailableControllersRequestFailure(error));
    }
  } catch (error) {
    console.log('error in doorControls saga', error);
    yield put(DoorControlsActions.getAvailableControllersRequestFailure(error));
  }
}

export function* getDoorControlControllers(api, { doorControlId, pageParams }) {
  try {
    const getDoorControlControllersResponse = yield api.getDoorControlControllers(doorControlId, pageParams);
    console.log('getDoorControlControllersResponse:', getDoorControlControllersResponse);
    if (getDoorControlControllersResponse.ok) {
      yield put(
        DoorControlsActions.getDoorControlControllersRequestSuccess(
          getDoorControlControllersResponse.data.content,
          getDoorControlControllersResponse.data.totalElements
        )
      );
    } else {
      api.checkAuth(getDoorControlControllersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof getDoorControlControllersResponse.problem !== 'undefined'
          ? getDoorControlControllersResponse.problem
          : typeof getDoorControlControllersResponse.data.error !== 'undefined'
          ? getDoorControlControllersResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(DoorControlsActions.getDoorControlControllersRequestFailure(error));
    }
  } catch (error) {
    console.log('error in doorControls saga', error);
    yield put(DoorControlsActions.getDoorControlControllersRequestFailure(error));
  }
}

export function* addDoorControlControllers(api, { doorControlId, controllers, pageParams }) {
  console.log('pageParams:', pageParams);
  try {
    const addDoorControlControllersResponse = yield api.addDoorControlControllers(doorControlId, controllers);
    console.log('addDoorControlControllersResponse:', addDoorControlControllersResponse);
    const getDoorControlControllersResponse = yield api.getDoorControlControllers(doorControlId, pageParams);
    console.log('getDoorControlControllersResponse:', getDoorControlControllersResponse);
    const successMessage = i18n.t('successMessage.addDoor');
    if (addDoorControlControllersResponse.ok && getDoorControlControllersResponse.ok) {
      yield put(
        DoorControlsActions.addDoorControlControllersRequestSuccess(
          getDoorControlControllersResponse.data.content,
          getDoorControlControllersResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(addDoorControlControllersResponse);
      api.checkAuth(getDoorControlControllersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof addDoorControlControllersResponse.problem !== 'undefined'
          ? addDoorControlControllersResponse.problem
          : typeof addDoorControlControllersResponse.data.error !== 'undefined'
          ? addDoorControlControllersResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(DoorControlsActions.addDoorControlControllersRequestFailure(error));
    }
  } catch (error) {
    console.log('error in doorControls saga', error);
    yield put(DoorControlsActions.addDoorControlControllersRequestFailure(error));
  }
}

export function* editDoorControlControllers(api, { doorControlId, controllers, pageParams }) {
  try {
    const editDoorControlControllersResponse = yield api.editDoorControlControllers(doorControlId, controllers);
    console.log('editDoorControlControllersResponse:', editDoorControlControllersResponse);
    const getDoorControlControllersResponse = yield api.getDoorControlControllers(doorControlId, pageParams);
    console.log('getDoorControlControllersResponse:', getDoorControlControllersResponse);
    const successMessage = i18n.t('successMessage.editDoor');
    if (editDoorControlControllersResponse.ok && getDoorControlControllersResponse.ok) {
      yield put(
        DoorControlsActions.editDoorControlControllersRequestSuccess(
          getDoorControlControllersResponse.data.content,
          getDoorControlControllersResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(editDoorControlControllersResponse);
      api.checkAuth(getDoorControlControllersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof editDoorControlControllersResponse.problem !== 'undefined'
          ? editDoorControlControllersResponse.problem
          : typeof editDoorControlControllersResponse.data.error !== 'undefined'
          ? editDoorControlControllersResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(DoorControlsActions.editDoorControlControllersRequestFailure(error));
    }
  } catch (error) {
    console.log('error in doorControls saga', error);
    yield put(DoorControlsActions.editDoorControlControllersRequestFailure(error));
  }
}

export function* deleteDoorControlControllers(api, { doorControlId, controllers, pageParams }) {
  try {
    const deleteDoorControlControllersResponse = yield api.deleteDoorControlControllers(doorControlId, controllers);
    console.log('deleteDoorControlControllersResponse:', deleteDoorControlControllersResponse);
    const getDoorControlControllersResponse = yield api.getDoorControlControllers(doorControlId, pageParams);
    console.log('getDoorControlControllersResponse:', getDoorControlControllersResponse);
    const successMessage = i18n.t('successMessage.deleteDoor');
    if (deleteDoorControlControllersResponse.ok && getDoorControlControllersResponse.ok) {
      yield put(
        DoorControlsActions.deleteDoorControlControllersRequestSuccess(
          getDoorControlControllersResponse.data.content,
          getDoorControlControllersResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(deleteDoorControlControllersResponse);
      api.checkAuth(getDoorControlControllersResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof deleteDoorControlControllersResponse.problem !== 'undefined'
          ? deleteDoorControlControllersResponse.problem
          : typeof deleteDoorControlControllersResponse.data.error !== 'undefined'
          ? deleteDoorControlControllersResponse.data.error
          : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(DoorControlsActions.deleteDoorControlControllersRequestFailure(error));
    }
  } catch (error) {
    console.log('error in doorControls saga', error);
    yield put(DoorControlsActions.deleteDoorControlControllersRequestFailure(error));
  }
}
